import { BaseRouteProps } from '../types/route-props';
import { ProductsApi } from '../types/api/products-api';
import { ATG_PRODUCT_CARD_MAIN_PATH, SPRYKER_PRODUCT_CARD_MAIN_PATH } from '../constants';
import { Method, callAxios, AxiosRequestConfig } from '../axios';
import { buildURL, isV3 } from '../common';
import { getBrandName } from '../locale';

export const getProductCardMainEndpointUrl = ({
  contextRoot,
  countryCode,
  languageCode,
}: BaseRouteProps): string => {
  if (isV3()) return SPRYKER_PRODUCT_CARD_MAIN_PATH;

  return buildURL({
    host: '',
    contextRoot,
    countryCode,
    languageCode,
    endpoint: ATG_PRODUCT_CARD_MAIN_PATH,
  });
};
export const productsApiFetchers = {
  getProductsFetcher: async ({
    contextRoot,
    countryCode,
    languageCode,
    params,
  }: BaseRouteProps & {
    params: ProductsApi.GetProductsParams;
  }) => {
    const GET_PRODUCTS_URL = getProductCardMainEndpointUrl({
      contextRoot,
      countryCode,
      languageCode,
    });
    const requestSettings: AxiosRequestConfig<unknown> = {
      method: Method.GET,
      url: GET_PRODUCTS_URL,
    };

    if (isV3()) {
      requestSettings.params = {
        'country-code': countryCode,
        'language-code': languageCode,
        brand: getBrandName(),
        ...params,
      };
    } else {
      requestSettings.params = params;
    }

    const response = await callAxios<{
      response: ProductsApi.GetProductsResponse;
    }>(requestSettings);

    return response.data;
  },
};
